import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import api from "../../utilis/api";

export const CreateTeacher = ({ onClose }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSignUp = async (e) => {
    e.preventDefault(); // prevent form reload

    const { firstName, lastName, email, phone, password, confirmPassword } =
      formData;

    if (!firstName || !lastName || !email || !password || !confirmPassword) {
      return toast.error("Please fill in all requeriesuired fields");
    }

    if (password !== confirmPassword) {
      return toast.error("Passwords do not match");
    }

    try {
      const name = `${firstName} ${lastName}`;

      const res = await api.post(
        "/user/register",
        {
          name,
          email,
          phone,
          password,
          role: "teacher",
          verificationMethod: "email",
        },
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      console.log(res.data);
      toast.success("Teacher account created successfully!");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
      });

      onClose(); // close modal after successful signup
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-container"
        onClick={(e) => e.stopPropagation()} // prevent overlay click close
      >
        <h2 className="modal-title">Create Teacher</h2>
        <form className="modal-form" onSubmit={handleSignUp}>
          <input
            className="modal-input"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
          />
          <input
            className="modal-input"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
          />
          <input
            className="modal-input"
            name="email"
            type="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
          />
          <input
            className="modal-input"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleChange}
          />
          <input
            className="modal-input"
            name="password"
            type="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
          />
          <input
            className="modal-input"
            name="confirmPassword"
            type="password"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={handleChange}
          />
          <div className="modal-buttons">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-submit">
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const EditTeacher = ({ onClose, teacher }) => {
  const [name, setName] = useState(teacher.name);
  const [email, setEmail] = useState(teacher.email);
  const [phone, setPhone] = useState(teacher.phone);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !phone) return;
    const res = await api.put(
      `/user/${teacher._id}`,
      {
        name,
        email,
        phone,
        // password,
        role: "teacher",
        verificationMethod: "email",
      },
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    if (res) {
      toast.success("Teacher Updated Successfully");
    }
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-container"
        onClick={(e) => e.stopPropagation()} // ✅ function instead of string
      >
        <h2 className="modal-title">Edit Teacher</h2>
        <form className="modal-form" onSubmit={handleSubmit}>
          <input
            className="modal-input"
            name="name"
            placeholder={teacher.name}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            className="modal-input"
            name="email"
            type="email"
            placeholder={teacher.email}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            className="modal-input"
            name="phone"
            placeholder={teacher.phone}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <div className="modal-buttons">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-submit">
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const ShowQueries = ({ onClose, queries }) => {
  // Helper to truncate messages
  const truncateMessage = (msg, wordLimit = 15) => {
    const words = msg.split(" ");
    if (words.length <= wordLimit) return msg;
    return words.slice(0, wordLimit).join(" ") + "...";
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "1rem",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#0f0f0f",
          color: "#fff",
          borderRadius: "20px",
          padding: "2rem",
          maxWidth: "650px",
          width: "100%",
          maxHeight: "85vh",
          overflowY: "auto",
          boxShadow: "0 12px 30px rgba(0,0,0,0.8)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          style={{
            textAlign: "center",
            color: "#e6be5d",
            marginBottom: "2rem",
            fontSize: "24px",
            fontWeight: 700,
            textShadow: "0 2px 5px rgba(0,0,0,0.5)",
          }}
        >
          User queriesueries
        </h2>

        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {queries ? (
            <div
              key={queries._id}
              style={{
                background: "linear-gradient(145deg, #1b1b1b, #111)",
                padding: "1rem 1.5rem",
                borderRadius: "12px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.5)",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 25px rgba(230,190,93,0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.5)";
              }}
            >
              <p
                style={{
                  margin: "0 0 0.3rem 0",
                  fontWeight: 700,
                  color: "#f5d06f",
                }}
              >
                Name:{" "}
                <span style={{ fontWeight: 400, color: "#fff" }}>
                  {queries.name}
                </span>
              </p>
              <p
                style={{
                  margin: "0 0 0.3rem 0",
                  fontWeight: 700,
                  color: "#f5d06f",
                }}
              >
                Email:{" "}
                <span style={{ fontWeight: 400, color: "#fff" }}>
                  {queries.email}
                </span>
              </p>
              <p style={{ margin: 0, color: "#ccc" }}>
                Message: {truncateMessage(queries.message)}
              </p>
            </div>
          ) : (
            <p style={{ textAlign: "center", color: "#aaa" }}>
              No queriesueries found
            </p>
          )}
        </div>

        <button
          onClick={onClose}
          style={{
            marginTop: "2rem",
            width: "100%",
            padding: "14px 0",
            borderRadius: "12px",
            border: "none",
            fontWeight: 700,
            fontSize: "16px",
            color: "#000",
            background: "linear-gradient(135deg, #e6be5d, #c9a23a)",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.boxShadow =
              "0 8px 20px rgba(230,190,93,0.8)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.boxShadow =
              "0 6px 18px rgba(230,190,93,0.7)")
          }
        >
          Close
        </button>
      </div>
    </div>
  );
};
